// Backend Flask URL - uses /api/backend proxy on VPS, falls back to env var or empty for relative URLs
export const HEROKU_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || '';

export const DB_CONFIG = {
  user: process.env.POSTGRES_USER,
  host: process.env.POSTGRES_HOST,
  database: process.env.POSTGRES_DATABASE,
  password: process.env.POSTGRES_PASSWORD,
  port: 5432,
  ssl: {
    rejectUnauthorized: false
  }
};

export const JWT_SECRET = process.env.JWT_SECRET;